
import React, { useState, useEffect } from "react";
import blogs from "../data/blogs";

export default function BlogCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % blogs.length);
    }, 3000); // Change blog every 3 seconds
    return () => clearInterval(interval);
  }, []);

  const blog = blogs[current];

  return (
    <div className="bg-white text-toast-blue p-6 rounded shadow-md border border-toast-gray w-full max-w-xl mx-auto text-center transition duration-500 ease-in-out">
      <h3 className="text-lg font-bold mb-2">{blog.title}</h3>
      <p className="text-sm text-gray-600 mb-2">{blog.content.slice(0, 160)}...</p>
      <a href="/blog" className="text-sm text-toast-blue hover:underline">Read More</a>
    </div>
  );
}
